import { render, staticRenderFns } from "./button-grid-help.vue?vue&type=template&id=4314809d"
import script from "./button-grid-help.vue?vue&type=script&lang=js"
export * from "./button-grid-help.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports